<template>
    <div>
        <!--Header Components-->
        <base-header class="pb-6" type="">
        <b-row class="align-items-center py-4">
            <b-col lg="12" cols="12">
                <!-- <h6 class="h2 text-white d-inline-block mb-0">{{$route.name}}</h6> -->
                <h6 class="h2 d-inline-block mb-0">{{language_terms[$route.name]}}</h6>
                <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
                    <route-breadcrumb/>
                </nav>
            </b-col>
        </b-row>
        </base-header>
        <div>
            <loading :active.sync="loading" 
              color= '#007bff'
              :width= '128'
              :height= '128'
              loader='dots'
              :can-cancel="true" 
              :is-full-page="true">
            </loading>
        </div>
        <b-container fluid class="mt--6 container-padding">
            <b-row>
                <b-col cols="12">
                    <div class="card-wrapper">
                        <b-card no-body>
                            <b-tabs pills card>
                                <b-tab :title="language_terms['BASIC_INFORMATION']" active>
                                    <b-card-text>
                                        <card>
                                            <div slot="header">
                                                <h3 >{{language_terms['BASIC_INFORMATION']}} 
                                                    <span v-if="asset_protocol.code">({{asset_protocol.code}})</span>
                                                </h3>
                                            </div>
                                            <b-row>
                                                <b-col cols="12" md="12">
                                                    <base-input :label="language_terms['NAME']" v-model="asset_protocol.name" :disabled="!is_edit"></base-input>
                                                </b-col>
                                                <b-col cols="12">
                                                    <base-input :label="language_terms['DATA']">
                                                        <textarea
                                                        class="form-control"
                                                        rows="10"
                                                        v-model="asset_protocol.data"
                                                        :disabled="!is_edit">
                                                        </textarea>
                                                    </base-input>
                                                </b-col>
                                                <b-col cols="12">
                                                    <base-input :label="language_terms['REMARKS']">
                                                        <textarea
                                                        class="form-control"
                                                        id="exampleFormControlTextarea1"
                                                        rows="3"
                                                        v-model="asset_protocol.remarks"
                                                        :disabled="!is_edit">
                                                        </textarea>
                                                    </base-input>
                                                </b-col>
                                            </b-row>
                                        </card>
                                    </b-card-text>
                                        <div class="floating-bar">
                                            <div class="floating-bar-container" align="center">
                                                <b-button-group>
                                                    <b-button class="transparent-btn" v-if="!is_edit" @click ="clickOnEdit()">
                                                        <i class="fas fa-edit mr-2 text-primary"></i>{{language_terms['EDIT']}}
                                                    </b-button>
                                                    <b-button class="transparent-btn" v-if="is_edit" @click="save()">
                                                        <i class="fas fa-save mr-2 text-info"></i>{{language_terms['SAVE']}}
                                                    </b-button>
                                                    <b-button class="transparent-btn" v-if="is_edit">
                                                        <i class="fas fa-times mr-2 text-warning"></i>{{language_terms['CANCEL']}}
                                                    </b-button>
                                                    <b-button class="transparent-btn" v-if="$route.params.id != '_new'">
                                                        <i class="fas fa-trash mr-2 text-danger"></i>{{language_terms['DELETE']}}
                                                    </b-button>
                                                </b-button-group>
                                            </div>
                                        </div>
                                </b-tab>
                            </b-tabs>
                        </b-card>
                    </div>
                </b-col>
            </b-row>
        </b-container>
    </div>
</template>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<script>
import { mapState } from "vuex";
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css'; 

export default 
{
    computed:{
        ...mapState({
            language_terms: state => state.languages.language_terms,
            selected_lang: state => state.languages.selected_langauge,
            asset_protocol_filter: state => state.assetProtocols.filter,
            asset_protocol_data: state=> state.assetProtocols.data,
            is_created:state =>state.assetProtocols.is_created,
            is_updated:state =>state.assetProtocols.is_updated
        })
    },
    components:{
        Loading
    },
    data(){
        return{
            loading:false,
            is_edit:false,
            asset_protocol:{
                code:"",
                rfid:{}
            }
        }
    },
    methods:{
        async searchAssetProtocols()
        {
            this.loading = true
            let filter = {keyword:"",active_only:"1"}
            if(this.asset_protocol_filter)
            {
                filter = this.asset_protocol_filter
            }
            await this.$store.dispatch('assetProtocols/quickSearch', filter)

            this.loading = false
        },
        async save()
        {
            if(this.$route.params.id == '_new')
            {
                await this.$store.dispatch("assetProtocols/create", this.asset_protocol);
                if(this.is_created)
                {
                    await this.searchAssetProtocols()
                    this.$router.push("/assetprotocols-management/asset-protocols")
                }
            }
            else
            {
                await this.$store.dispatch("assetProtocols/update", this.asset_protocol);
                if(this.is_updated)
                {
                    await this.searchAssetProtocols()
                    this.$router.push("/assetprotocols-management/asset-protocols")
                }
            }
        },
        clickOnEdit()
        {
            this.is_edit = true
        },
        async retrieveAsset(asset_protocol_code)
        {
            this.loading=true
            await this.$store.dispatch("assetProtocols/fetch", {code:asset_protocol_code});
            this.loading=false
        }
    },
    async mounted()
    {
        this.loading = true
        if(this.$route.params.id == '_new')
        {
            this.is_edit = true
        }
        else
        {
            await this.retrieveAsset(this.$route.params.id)
            this.asset_protocol = this.asset_protocol_data

        }

        this.loading = false
    }

}
</script>
